import Navbar from '../components/navbar';
import {ListingBanner} from '../components/propertyLisiting';

import { Propertyavailableexchange, KnowMoreIsc} from '../components/index';
import React from 'react';
import '../css/main.css';
import {AddPropertyForm} from '../components/AddPropertyForm';

const PropertyAdd = () =>{
    return(
        <>
        <Navbar />
        <ListingBanner />
        <AddPropertyForm />
        <div style={{background:"#faf5fb"}}>
        <Propertyavailableexchange />
        </div>
        <KnowMoreIsc />


        </>
    )
}
export default PropertyAdd;